// src/components/FormDetails.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap styles
import { useNavigate, Link } from 'react-router-dom';
import {Navbar, Nav , Container, Button, Modal, Table, Card} from 'react-bootstrap';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import JsBarcode from "jsbarcode";

const FormDetails = () => {
  const [formDetails, setFormDetails] = useState(null);
  const { applicationNumber } = useParams();
  const [photoURL, setphotoURL] = useState("");
  const [signURL, setsignURL] = useState("");

  const navigate = useNavigate();



  function generatePDF() {
    const pdf = new jsPDF('p', 'mm', 'a4');

    //watermarking
    // Watermark text
    const watermarkText = "LPSSRB CONSTABLE";

    // Add watermark to each page
    const addWatermark = () => {
        pdf.setFontSize(50); // Set font size for the watermark
        pdf.setTextColor(150, 150, 150); // Set a light gray color for the watermark
        pdf.setDrawColor(150, 150, 150); // Set border color if needed
        pdf.setGState(new pdf.GState({ opacity: 0.2 })); // Set opacity for the watermark
        pdf.text(
            watermarkText,
            pdf.internal.pageSize.getWidth() / 2,
            pdf.internal.pageSize.getHeight() / 2,
            { align: 'center', angle: 45 } // Center and rotate the text
        );
    };

    const addWatermarkBorder = () => {
      const text = "LPSSRB"; // Repeating watermark text
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const textSpacing = 15.5; // Space between lines for vertical text

      pdf.setFontSize(10); // Set font size for the watermark text
      pdf.setTextColor(150, 150, 150); // Set a light gray color for the watermark text
      pdf.setGState(new pdf.GState({ opacity: 0.5 })); // Set opacity for the watermark

      // Top border
      let xPos = 7; // Start position for top border text
      while (xPos < pageWidth - 20) {
          pdf.text(text, xPos, 4, { baseline: 'middle' });
          xPos += pdf.getTextWidth(text); // Increment by the width of the text
      }

      // Bottom border
      xPos = 7;
      while (xPos < pageWidth - 20) {
          pdf.text(text, xPos, pageHeight - 12.6, { baseline: 'middle' });
          xPos += pdf.getTextWidth(text);
      }

      // Left border
      let yPos = 20; // Start position for left border text
      while (yPos < pageHeight - 6) {
          pdf.text("LPSSRB", 10, yPos, { angle: 90 }); // Rotate text for vertical alignment
          yPos += textSpacing; // Add spacing between text
      }

      // Right border
      yPos = 20;
      while (yPos < pageHeight - 6) {
          pdf.text("LPSSRB", pageWidth - 10, yPos, { angle: 90 }); // Rotate text for vertical alignment
          yPos += textSpacing; // Add spacing between text
      }
  };

    // Define the content of the table
    const tableContent = [];
    var esm = false;
    var esm_service = "";

    var full_name = "";
    formDetails && Object.keys(formDetails).forEach(key => {
      var keyName= key
      console.log(key)
      if(key ==="applicationNumber"){
        keyName = "Application Number"
      }else if (key === "postGroup"){
        return
        keyName = "Groups"
        formDetails[key] = formDetails[key].slice(2,-2)
      }else if (key ==="email"){
        keyName = "Email"
      }else if (key === "Posts"){
        formDetails[key] = JSON.parse(formDetails[key]).join(", ");
      }else if(key === "bonus"){
        keyName = "Desired Qualification"
        if(formDetails[key] === "noBonus"){
          formDetails[key] = "Not Applied"
        }
      }else if(key === "dob"){
        formDetails[key] = formDetails[key].split('-').reverse().join('/')
      }
      else if (key === "Name"){
        full_name = full_name + "" +formDetails[key]
        return
      }else if (key === "mName"){
        full_name = full_name + " " +formDetails[key]
        return
      }else if (key === "lName"){
        full_name = full_name + " " +formDetails[key]
        return
      }
      else if (key === "fName"){
        keyName = "Father's Name"
        tableContent.push(["FULL NAME", full_name])
      }
      else if (key === "criminal"){
        keyName = "Involvement in Criminal Case"
      }
      else if (key === "fullAddress"){
        keyName = "Full Address"
      }else if (key === "gender"){
        keyName = "Sex"
      }else if (key ==="status"){
        keyName = "Payment Status"
      }else if (key === "dob"){
        keyName = "Date of Birth"
      }else if (key === "zipcode"){
        keyName = "Pincode"
      }else if (key === "petCenter"){
        keyName = "Preferred Center for PET"
      }else if(key === "writtenCenter"){
        keyName = "Preferred Center for Written Exam"
      }else if(key === "city"){
        keyName = "City/Town/Village"
      } else if (key === "specialCategory") {
        keyName = "Special Category"
      }
      else if (key === "esm_years"){
        if(esm){
          esm_service = esm_service+formDetails[key]+" Years"
        }
        return
      }else if (key === "esm_months"){
        if(esm){
          esm_service = esm_service+" "+formDetails[key]+" Months"
        }
        return
      }else if (key === "esm_days"){
        if(esm){
          esm_service = esm_service+" "+formDetails[key]+" Days"
        }
        return
      }
      tableContent.push([keyName, formDetails[key]]);
    });
    if(esm){
      tableContent.push(["ESM Service Period", esm_service ]);
    }



    //add logo
    pdf.addImage("/logo_32.png", 'PNG', 14, 5, 182, 14);


    // Add the heading text at the calculated position
    const headingText = "THE ADMINISTRATION OF UNION TERRITORY OF LADAKH\nLADAKH POLICE SUBORDINATE SERVICE RECRUITMENT BOARD (LPSSRB)"
    // Define the styling for the heading text
    const styles = {
      fontStyle: 'bold', // Make the text bold
      fontSize: 10, // Set the font size
      cellWidth: 'wrap', // Wrap the text within the cell
      halign: 'center', // Center align the text horizontally
      valign: 'middle', // Center align the text vertically
      fillColor: false, // Disable fill color for the cell
      textColor: [0, 0, 0], // Set text color to black
      lineColor: [0, 0, 0], // Set line color for the cell border
      lineWidth: 0.1, // Set line width for the cell border
      cellPadding: 2, // Set padding for the cell
      textDecoration: 'underline', // Add underline to the text
    };

    // Add the heading text using autoTable
    pdf.autoTable({
      startY: 20, // Set the starting y-coordinate for the table
      body: [[headingText]], // Pass the heading text as a single-row array
      theme: 'grid', // Set the table theme to 'grid' for border styling
      styles: styles, // Apply the custom styles to the heading text
    });

    pdf.autoTable({
      startY: pdf.autoTable.previous.finalY, // Set the starting y-coordinate for the table
      body: [["Application Form under Advertisment Notice No. 02/2026, dated 24.08 2026"]], // Pass the heading text as a single-row array
      theme: 'grid', // Set the table theme to 'grid' for border styling
      styles: styles, // Apply the custom styles to the heading text
    });



    // Generate the barcode as an image
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, formDetails.applicationNumber, {
      format: "CODE128",
      displayValue: true,
      fontOptions: "OCR-B"
    });

    // Convert the canvas to a data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");

    // Add the barcode image to the PDF
    pdf.addImage(barcodeDataURL, "PNG", 135, 45, 60, 40);


    pdf.setFontSize(10);
    pdf.addImage(photoURL, 'JPEG', 15, 43, 35, 45);
    pdf.addImage(signURL, 'JPEG', 140, 275, 40, 20);
    // Add the table to the PDF

    const styles2 = {
      fontStyle: 'bold', // Make the text bold
      fontSize: 10, // Set the font size
      cellWidth: 'wrap', // Wrap the text within the cell
      halign: 'center', // Center align the text horizontally
      valign: 'middle', // Center align the text vertically
      fillColor: [6, 33, 63], // Disable fill color for the cell
      textColor: [255, 255, 255], // Set text color to black
      lineColor: [0, 0, 0], // Set line color for the cell border
      lineWidth: 0.1, // Set line width for the cell border
      cellPadding: 2, // Set padding for the cell
      textDecoration: 'underline', // Add underline to the text
    };
    pdf.autoTable({
      startY: 90, // Set the starting y-coordinate for the table
      body: [["Form Details"]], // Pass the heading text as a single-row array
      theme: 'grid', // Set the table theme to 'grid' for border styling
      styles: styles2, // Apply the custom styles to the heading text
    });
    const uppercaseTableContent = tableContent.map(row => row.map(cell => typeof cell === 'string' ? cell.toUpperCase() : cell));
    pdf.autoTable({startX: 15, startY: 97, head: [], body: uppercaseTableContent , theme: "striped", styles: { lineColor: [0,0,0], lineWidth: 0.1, fontSize: 7}});




    const disclaimer = "• I declare that I have not been convicted in any criminal case and that no criminal case is pending against me before any court of law. I further declare that no FIR, criminal proceeding, or prosecution requiring disclosure under the recruitment rules has been concealed by me. I understand that suppression of material information or furnishing false information shall render my candidature/appointment liable to cancellation at any stage.\n• I undertake to disclose all criminal cases, whether pending or decided, in the relevant section of the application form. Suppression of any such information shall lead to cancellation of candidature and may invite legal action.\n• I declare that the information provided above is true and correct to the best of my knowledge and understanding. I understand that if any information is found to be incorrect or false, my candidature may be cancelled at any time."
    // Define the styling for the heading text
    const styles3 = {
      fontStyle: 'bold', // Make the text bold
      fontSize: 8, // Set the font size
      cellWidth: 'wrap', // Wrap the text within the cell
      halign: 'left', // Center align the text horizontally
      valign: 'middle', // Center align the text vertically
      fillColor: false, // Disable fill color for the cell
      textColor: [0, 0, 0], // Set text color to black
      lineColor: [0, 0, 0], // Set line color for the cell border
      lineWidth: 0.1, // Set line width for the cell border
      cellPadding: 2, // Set padding for the cell
      textDecoration: 'underline', // Add underline to the text
    };
    const styles4 = {
      fontStyle: 'bold', // Make the text bold
      fontSize: 8, // Set the font size
      cellWidth: 'wrap', // Wrap the text within the cell
      halign: 'center', // Center align the text horizontally
      valign: 'middle', // Center align the text vertically
      fillColor: false, // Disable fill color for the cell
      textColor: [0, 0, 0], // Set text color to black
      lineColor: [0, 0, 0], // Set line color for the cell border
      lineWidth: 0.1, // Set line width for the cell border
      cellPadding: 2, // Set padding for the cell
      textDecoration: 'underline', // Add underline to the text
    };

    // Add the heading text using autoTable
    pdf.autoTable({
      startX: 15,
      startY: 235, // Set the starting y-coordinate for the table
      body: [["Declaration"]], // Pass the heading text as a single-row array
      theme: 'grid', // Set the table theme to 'grid' for border styling
      styles: styles2, // Apply the custom styles to the heading text
    });
    pdf.autoTable({
      startX: 15,
      startY: 243, // Set the starting y-coordinate for the table
      body: [[disclaimer]], // Pass the heading text as a single-row array
      theme: 'grid', // Set the table theme to 'grid' for border styling
      styles: styles3, // Apply the custom styles to the heading text
    });


    // Get current date and time
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;

    // Set footer content
    const footerContent = `Generated at: ${formattedDate} ${formattedTime}`;

    pdf.text(footerContent, 15, 280);

    addWatermark();
    addWatermarkBorder();

    // Save the PDF
    pdf.save(applicationNumber+'formDetails.pdf');
  }


  const handleGoBack = () => {
    navigate("/home")
  };

  useEffect(() => {

    console.log(applicationNumber)
    // Fetch form details using Axios (replace the URL with your actual endpoint)

    //get photo and signature
    axios.get("/api/getImages").then(response => {
      console.log(response.data)
      setphotoURL(response.data.photoUrl)
      setsignURL(response.data.signURL)
    })

    axios.post(`/api/getFormDetails`, { applicationNumber })
      .then(response => {
        if(response.data.status === 0){
          response.data.status = "Payment Failed"
        }else if(response.data.status === 1){
          response.data.status = "Payment Successful"
        }else if(response.data.status === 2){
          response.data.status = "Payment Pending. Wait for clearance"
        }
        setFormDetails(response.data);
      })
      .catch(error => {
        console.error('Error fetching form details:', error);
        navigate("/");
      });
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center' , padding: '15px',backgroundColor:"#06213f"}}>
        <img src="/logo_0.png" alt="Header Image" style={{ height: '100px', backgroundColor:"#06213f"}} />
      </div>
      <Navbar variant="dark" style={{ backgroundColor: '#06213f'}}>
        <Container>
          <Navbar.Brand href="/home">Ladakh Police Constable Recruitment 2026</Navbar.Brand>
          <Nav className="me-auto">
          </Nav>
          <Navbar.Collapse className="justify-content-end">
          <Navbar.Text>
            Signed in as: {(formDetails? formDetails.Phone : "Loading")}
          </Navbar.Text>
        </Navbar.Collapse>
        </Container>
      </Navbar>
      <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: '#dee0d7', padding: '20px' }}>


        <Card className="shadow-sm" style={{ borderColor: "#000", maxWidth: "80rem", width: '100%'}}>
          <Card.Body>
          <h2 style={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold'}}>Form Details  {formDetails? "("+formDetails.applicationNumber+")": " "}</h2>
          <br></br>
          {formDetails ? (
            <table id="formDetailsTable" className="table table-bordered">
              <tbody>
                <tr>
                  <th>Full Name</th>
                  <td>{formDetails.Name.toUpperCase()+" "+formDetails.mName.toUpperCase()+" "+formDetails.lName.toUpperCase()}</td>
                </tr>
                <tr>
                  <th>Father's Name</th>
                  <td>{formDetails.fName.toUpperCase()}</td>
                </tr>
                <tr>
                  <th>District</th>
                  <td>{formDetails.district.toUpperCase()}</td>
                </tr>
                <tr>
                  <th>Pincode</th>
                  <td>{formDetails.zipcode}</td>
                </tr>
                <tr>
                  <th>Sex</th>
                  <td>{formDetails.gender.toUpperCase()}</td>
                </tr>
                <tr>
                  <th>DOB (dd/mm/yyy)</th>
                  <td>{formDetails.dob.split('-').reverse().join('/')}</td>
                </tr>
                <tr>
                  <th>Category</th>
                  <td>{formDetails.category.toUpperCase()}</td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>{formDetails.email.toUpperCase()}</td>
                </tr>
                <tr>
                  <th>Application Number</th>
                  <td>{formDetails.applicationNumber}</td>
                </tr>
                <tr>
                  <th>Posts Applied</th>
                  <td>{JSON.parse(formDetails.Posts).join(", ")}</td>
                </tr>
                <tr>
                  <th>Phone</th>
                  <td>{formDetails.Phone}</td>
                </tr>
                <tr>
                  <th>Special Category</th>
                  <td>{formDetails.specialCategory}</td>
                </tr>
                <tr>
                  <th>NCC</th>
                  <td>{formDetails.ncc}</td>
                </tr>
                <tr>
                  <th>Involvement in Criminal Case(s)</th>
                  <td>{formDetails.criminal.toUpperCase()}</td>
                </tr>
                <tr>
                  <th>Payment Status</th>
                  <td>{formDetails.status}</td>
                </tr>
              </tbody>
            </table>
          ) : (
            <div className="alert alert-info" role="alert">
              Loading form details...
            </div>
          )}



        <center>
          <Button onClick={generatePDF} variant="primary" style={{ marginRight: '10px', backgroundColor: '#06213f'}}>Print Form</Button>{' '}
          <Button onClick={handleGoBack} variant="danger">Go Back</Button>{' '}
        </center>


        </Card.Body>
        </Card>
    </div>


  </div>
  );
};

export default FormDetails;
